import axiosInstance from '@/setup/axios/axiosInstance';
import type { InventoryItemOption } from '../models/ItemModel';

interface MaterialGroupApiItem {
  id: string | number;
  name?: string;
  title?: string;
  code?: string;
  company_id?: string;
  company?: {
    id?: string;
    company_id?: string;
  };
}

const toInventoryItemOption = (item: MaterialGroupApiItem): InventoryItemOption => ({
  id: String(item.id),
  name: item.name || item.title || item.code || String(item.id),
  company_id: item.company_id || item.company?.company_id || item.company?.id,
});

const unwrapListData = (data: any): MaterialGroupApiItem[] => {
  if (Array.isArray(data)) {
    return data;
  }

  if (Array.isArray(data?.results)) {
    return data.results;
  }

  return [];
};

export const getMaterialGroupOptions = async (companyId?: string): Promise<InventoryItemOption[]> => {
  const params: Record<string, string> = {};
  if (companyId) {
    params.company = companyId;
  }

  const response = await axiosInstance.get('/inventory/material-groups/', { params });
  const items = unwrapListData(response.data);
  return items.map(toInventoryItemOption);
};

export const createMaterialGroupOption = async (payload: { name: string; company_id: string }): Promise<InventoryItemOption> => {
  const response = await axiosInstance.post('/inventory/material-groups/', payload);
  return toInventoryItemOption(response.data);
};
